module.exports = __webpack_public_path__ + "static/N2N5-5ee5d1f9900f3fa4be0a3ee0bcd041cf.jpg";